import { TFunction } from "react-i18next";

export type DayOfWeek = 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday';

export const mapToLocalDayOfWeekName = (t : TFunction<string>, dayOfWeek: DayOfWeek) => t(`daysOfWeek.${dayOfWeek}`);